if (!customElements.get('uw-purchase-options')) {
  customElements.define('uw-purchase-options', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('[data-purchase-open]');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.opener.addEventListener('click', event => {
        event.preventDefault();
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      });
      this.querySelector('[data-purchase-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        const bounds = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.opener.focus();
      });
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        document.documentElement.style.overflow = this.previousOverflow || '';
      }
    }
  });
}